export default {
  getReferences: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/references/getters.js